import { PagerdutyIconUrl } from "@p0security/integrations-pagerduty-shared";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { PagerdutyAiAccesses } from "./accesses.ts";
import { PagerdutyAiComponents } from "./components.ts";

const PagerdutyAiFilters = {
  account: { keys: ["name"] },
  // Rule filter values compile to regular expressions, so rules can scope by
  // resource ("incidents\..*"), by verb (".*\.read"), or exactly
  // ("incidents\.read").
  policy: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type PagerdutyAiFilters = typeof PagerdutyAiFilters;

export const PagerdutyAiRegistration = Registration({
  accesses: PagerdutyAiAccesses,
  category: "resource",
  components: PagerdutyAiComponents,
  docs: {
    install: "agentic-gateway/mcp-server/pagerduty",
    request: "agentic-gateway/requesting-access",
  },
  filters: PagerdutyAiFilters,
  itemKind: "Account",
  label: "PagerDuty",
  logoUrl: PagerdutyIconUrl,
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "credential" }],
});

registerIntegration("pagerduty-ai", PagerdutyAiRegistration);
